import React, { useEffect, useRef } from 'react';
import { Box, Grid, Container, List, ListItem } from '@mui/material';
import StyledBox from 'views/rebranded-module/OffRoadToursLandingViewV2/components/OffRoadToursHighlightsSection/OffRoadToursHighlightsSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { Typography700 } from 'views/rebranded-module/common/components';
import { RiMotorbikeLine, RiCheckboxCircleLine } from 'react-icons/ri';
import EagleRide from 'views/rebranded-module/common/icons/EagleRide';
import Typography500 from 'views/common/components/UI/Typography500';

const OffRoadToursHighlightsSection = () => {
  const content = useContent('OffRoadLandingPage');

  const icons = [
    <RiMotorbikeLine className="OTHSIcon" />,
    <RiCheckboxCircleLine className="OTHSIcon" />,
    <EagleRide className="OTHSIcon" />,
  ];

  const [maxTitleHeight, setMaxTitleHeight] = React.useState(0);
  const titleRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const validHeights = titleRefs.current
      .filter((el): el is HTMLDivElement => el !== null)
      .map((el) => el.clientHeight);

    if (validHeights.length > 0) {
      setMaxTitleHeight(Math.max(...validHeights));
    }
  }, [content.highLightsList]);
  return (
    <StyledBox maxTitleHeight={maxTitleHeight}>
      <Container maxWidth="xl">
        <Typography700 variant="h4" component="h2" mb={3}>
          {content.highLightsTitle}
        </Typography700>

        <Typography500
          component="p"
          variant="body1"
          color="text.secondary"
          mb={8}>
          {content.highLightsDescription}
        </Typography500>

        <Grid container spacing={4}>
          {content.highLightsList.map((item, index) => (
            <Grid item lg={4} md={12} sm={12} key={item.title}>
              <Box className="OTHighLightItem">
                {icons[index]}

                <Box
                  className="OTHighLightItemTitle"
                  ref={(el) => {
                    titleRefs.current[index] = el as HTMLDivElement | null;
                  }}>
                  <Typography700 variant="h5" component="h2">
                    {item.title}
                  </Typography700>
                </Box>

                <List className="OTHSList">
                  {item.description.map((desc: string) => (
                    <ListItem
                      className="OTHSListItem"
                      key={desc}
                      disableGutters>
                      <Typography500
                        component="p"
                        variant="body2"
                        color="text.secondary">
                        {desc}
                      </Typography500>
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </StyledBox>
  );
};

export { OffRoadToursHighlightsSection };
